import type { SettingsSectionId } from '../nav/settings-nav-sections'
import { PreferencesPanel } from './PreferencesPanel'
import { ConnectedAccountsPanel } from './ConnectedAccountsPanel'
import { SubscriptionPanel } from './SubscriptionPanel'
import { CreateOrganizationPanel } from './CreateOrganizationPanel'
import { MembersPanel } from './MembersPanel'
import { BillingPanel } from './BillingPanel'

/** Routes the active section id to its panel (same factory shape as EventBubbleConstructor). */
export function SettingsPanelHost({ sectionId }: { sectionId: SettingsSectionId }) {
  switch (sectionId) {
    case 'preferences':
      return <PreferencesPanel />
    case 'connected-accounts':
      return <ConnectedAccountsPanel />
    case 'subscription':
      return <SubscriptionPanel />
    case 'create-organization':
      return <CreateOrganizationPanel />
    case 'members':
      return <MembersPanel />
    case 'billing':
      return <BillingPanel />
    default:
      return null
  }
}
